import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Helmet, HelmetProvider } from "react-helmet-async";
import PreviewDownloads from "../PublishScalePage/PreviewDownloads";
import LibraryHelp from "./LibraryHelp";
import RenderData from "../../store/RenderData";
import PublishScalePage from "../PublishScalePage/PublishScalePage";
import classes from "./LibraryPage.module.css";
import buttonClasses from "../UI/Button.module.css";

const NewTabIcon = () => <svg className={classes.newTabIcon} width="12" height="12" viewBox="0 0 16 16"
  fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" focusable="false">
  <path d="M9 2h5v5M14 2 7 9M6 3H2v11h11v-4" />
</svg>;

// Mounted only after this route's synchronous URL load succeeds. The child
// renderer runs before the ready effect, so old published images never appear.
const PublicLibrarySheet = ({ entry, source }) => {
  const published = useRef(null);
  const help = useRef(null);
  const [ready, setReady] = useState(false);
  const chartCount = useSelector(state => state.publishedData.length);
  const guitarSetup = useSelector(state => state.guitarSetup);
  useEffect(() => { setReady(true); }, []);
  return <>
    <RenderData />
    {ready && <>
      <HelmetProvider><Helmet>
        <title>{entry ? `${entry.name} | Guitar Charts` : "Guitar Chart Library | Guitar Charts"}</title>
        <link rel="canonical" href={`https://guitar-charts.com/${entry?.slug || "library"}`} />
        <meta name="description" content={entry
          ? `${entry.name} guitar fretboard charts with ${chartCount} positions in ${guitarSetup} tuning. View printable diagrams or customise the fingerings in Guitar Charts.`
          : "Browse guitar scale, mode, interval and arpeggio charts. View printable fretboard diagrams and customise their fingerings in Guitar Charts."} />
      </Helmet></HelmetProvider>
      <nav className={classes.publicActions} aria-label="Collection actions">
        <a className={`${buttonClasses.button} ${classes.actionLink}`} href={`/publish/?${source}`} target="_blank" rel="noopener noreferrer" aria-describedby="library-new-tab">View Printable Sheet<NewTabIcon /></a>
        <a className={`${buttonClasses.button} ${classes.actionLink}`} href={`/?${source}`} target="_blank" rel="noopener noreferrer" aria-describedby="library-new-tab">Customise a copy<NewTabIcon /></a>
        <PreviewDownloads publishedRef={published} pdfLabel="Download PDF" imagesLabel="Download Images" />
        <div className={classes.actionNotes}>
          <span id="library-new-tab" hidden>Opens in a new tab.</span>
          <a className={classes.helpLink} href="#library-help" onClick={() => { help.current.open = true; }}>Library help</a>
        </div>
      </nav>
      <div ref={published} className={`${classes.publishBorder} ${classes.publicSheet}`}>
        <PublishScalePage manageMetadata={false} />
      </div>
      <LibraryHelp detailsRef={help} />
    </>}
  </>;
};

export default PublicLibrarySheet;
